import { useEffect, useState } from "react";
import axios from "axios";

let pending = 0;
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn(pending > 0));
}

axios.interceptors.request.use((config) => {
  pending += 1;
  emit();
  return config;
});
axios.interceptors.response.use(
  (res) => {
    pending = Math.max(0, pending - 1);
    emit();
    return res;
  },
  (err) => {
    pending = Math.max(0, pending - 1);
    emit();
    return Promise.reject(err);
  },
);

export default function RequestProgress() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    listeners.add(setOn);
    return () => listeners.delete(setOn);
  }, []);
  if (!on) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[200] h-0.5 bg-transparent" aria-hidden>
      <div className="h-full w-1/3 bg-[#f37721] animate-pulse rounded-full" style={{ width: "100%", animation: "bmj-progress 1.1s ease-in-out infinite" }} />
      <style>{`@keyframes bmj-progress { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
}

export function InlineLoader({ label = "Loading…" }) {
  return (
    <div className="flex items-center gap-2 py-3 text-sm text-[#673c96]" role="status">
      <span className="h-4 w-4 rounded-full border-2 border-[#673c96] border-t-transparent animate-spin" />
      <span>{label}</span>
    </div>
  );
}
